import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import React from 'react';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

import TooltipDialog from './orderNew/tooltipDialog/tooltipDialog';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';

import { AntSwitch } from './sider.utils';
import { useTranslation } from 'react-i18next';

function MultiProductAccordion({
  multiProduct,
  polygonArea,
  overlapDialogRef,
}: {
  multiProduct: any;
  polygonArea: any;
  overlapDialogRef: any;
}) {
  const { t } = useTranslation('orderImagery');

  return (
    <Accordion className="skywatch-accordian adv-setting-accordian ">
      <AccordionSummary
        expandIcon={<KeyboardArrowDownOutlinedIcon />}
        aria-controls="panel2-content"
        id="panel2-header"
        aria-label="multi-product-show-btn"
      >
        <Stack direction="row" gap={1} alignItems="center">
          <SettingsOutlinedIcon />
          <Typography>{t('advancedSettings', 'Advanced Settings')}</Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Box>
          <Stack
            justifyContent={'space-between'}
            direction="row"
            alignItems="center"
            flexWrap="wrap"
            gap={1}
          >
            <Stack spacing={1} direction="row" alignItems="center" className="combine-wrap">
              <i className="icon-combine"></i>
              <Typography fontSize={14} className="mf-title">
                {t('combineMultipleImage')}
              </Typography>
              <TooltipDialog
                title={t('combineInSingle')}
                name={''}
                closeName={''}
                /* eslint-disable react/no-children-prop */
                children={
                  <Box className="combine-popover-content">
                    <Typography variant="caption" gutterBottom display="block">
                      {t('multiOrderPara1')}
                    </Typography>
                    <Typography variant="caption" gutterBottom display="block">
                      {t('notRecommendedOption')}
                    </Typography>
                  </Box>
                }
              />
            </Stack>
            <Tooltip
              title={t('multiProductSwitchTooltip')}
              className="map-tooltip-wrap"
              placement="right"
              disableHoverListener={!(polygonArea < 25)}
              slotProps={{
                tooltip: {
                  sx: {
                    color: '#fff',
                    backgroundColor: '#496178',
                    padding: '8px',
                  },
                },
                popper: {
                  modifiers: [
                    {
                      name: 'offset',
                      options: {
                        offset: [0, 6],
                      },
                    },
                  ],
                },
              }}
            >
              <Box>
                <AntSwitch
                  checked={multiProduct}
                  disabled={polygonArea < 25}
                  aria-label="multi-product-switch"
                  onChange={event => {
                    //if it is on open the multi product dialog
                    if (event.target.checked) {
                      // setOpenMultiProductDialog(true);

                      overlapDialogRef.current.click1();
                    } else {
                      overlapDialogRef.current.click2();
                      // Reset merge option on disable
                    }
                  }}
                />
              </Box>
            </Tooltip>
            {/* <AntSwitch
            checked={multiProduct}
            disabled={polygonArea < 25}
            onChange={event => {
              //if it is on open the multi product dialog
              if (event.target.checked) {
                // setOpenMultiProductDialog(true);
                overlapDialogRef.current.click1();
              } else {
                overlapDialogRef.current.click2();
                // Reset merge option on disable
              }
            }}
          /> */}
          </Stack>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}

export default MultiProductAccordion;
